import { render, staticRenderFns } from "./page3part4.vue?vue&type=template&id=096b9530&scoped=true"
var script = {}
import style0 from "./page3part4.vue?vue&type=style&index=0&id=096b9530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b9530",
  null
  
)

export default component.exports